module.exports = __webpack_public_path__ + "static/img/iconmonstr-magnifier-2.3ab4627d.svg";